import { wrapCall, callGet } from './helpers'

type KVArray = {
  key: string
  value: string
}[]

type Environment = {
  name: string
  user: APIUser
  settings: KVArray
  config: {
    users: KVArray
    custom: KVArray
    system: KVArray
    reporting: KVArray
    notifications: KVArray
  }
  permissions: string[]
  billing: any
}

// Gets auth account info for the user
export const getEnvironment = async () => {
  return (await wrapCall({
    method: callGet,
    uri: '/environments/workspace'
  })) as Environment
}
